__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/98f8a5c/";